import { useState } from 'react';
import TopArrow from '../../assets/images/top-arrow.svg';
import DownArrow from '../../assets/images/down-arrow.svg';

export default function Collapse({ title, children }) {
  const [open, setOpen] = useState(false);

  return (
    <div>
        <button onClick={() => setOpen(!open)} className="w-full cursor-pointer border-b border-[#F5F5F5] px-4 py-3 flex items-center justify-between">
            <span className="text-xs font-normal text-[#414651]">{title}</span>
            {open ? (
                <div className="w-5 h-5 flex items-center justify-center">
                    <img src={TopArrow} alt="Top Arrow Icon" className="w-[12.5px] h-[6.25px]" />
                </div>
            ) : (
                <div className="w-5 h-5 flex items-center justify-center">
                    <img src={DownArrow} alt="Down Arrow Icon" className="w-[12.5px] h-[6.25px]" />
                </div>
            )}
        </button>

        {open && children }
    </div>
  );
}
